// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__NMQsd","title":"InfoRow_title__1fqJf"};